import Layout from "@/shared/layout";
import { ReactNode } from "react";
import { Navigation } from "@/modules/common/features/navigation";
import Header from "./header";
import { Grid } from "./grid/grid";
import { VarsConsumer, VarsProvider } from "./vars/vars";
import { BreadcrumbsPortal } from "@/shared/page";

export default function BaseLayout({ children }: { children: ReactNode }) {
  return (
    <Vars>
      <Screen>
        <Grid
          content={children}
          header={<Header />}
          navigation={<Navigation />}
          breadcrumbs={<BreadcrumbsPortal />}
        />
      </Screen>
    </Vars>
  );
}

function Screen({ children }: { children: ReactNode }) {
  return <Layout className="!min-h-screen flex !flex-col">{children}</Layout>;
}

function Vars({ children }: { children: ReactNode }) {
  return (
    <VarsProvider>
      <VarsConsumer>
        {(value) => <div style={value}>{children}</div>}
      </VarsConsumer>
    </VarsProvider>
  );
}
